import { FLOW_ID } from '@src/common/AppConstants';

export const PAApageData = {
  [FLOW_ID.PROVIDER]: [
    {
      step: 1,
      name: 'Access Administrator',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Company Verification',
      complete: false,
      url: '/PAARegistration/companyVerification',
    },
    {
      step: 3,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 4,
      name: 'Job Functions',
      complete: false,
      url: '/PAARegistration/jobFunction',
    },
    {
      step: 5,
      name: 'Review & Confirm',
      complete: false,
      url: '/PAARegistration/reviewConfirm',
    },
  ],
  [FLOW_ID.API_MARKETPLACE_PROVIDER]: [
    {
      step: 1,
      name: 'Attestation',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Company Verification',
      complete: false,
      url: '/PAARegistration/companyVerification',
    },
    {
      step: 3,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 4,
      name: 'Job Functions',
      complete: false,
      url: '/PAARegistration/jobFunction',
    },
    {
      step: 5,
      name: 'API Access',
      complete: false,
      url: '/PAARegistration/apiAccess',
    },
    {
      step: 6,
      name: 'Review & Confirm',
      complete: false,
      url: '/PAARegistration/reviewConfirm',
    },
  ],
  [FLOW_ID.BILLING]: [
    {
      step: 1,
      name: 'Access Administrator',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 3,
      name: 'Company Verification',
      complete: false,
      url: '/PAARegistration/companyVerification',
    },
  ],
  [FLOW_ID.VENDOR]: [
    {
      step: 1,
      name: 'Access Administrator',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 3,
      name: 'Company Verification',
      complete: false,
      url: '/PAARegistration/companyVerification',
    },
  ],
  [FLOW_ID.API_MARKETPLACE_BILLING]: [
    {
      step: 1,
      name: 'Attestation',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 3,
      name: 'API Access',
      complete: false,
      url: '/PAARegistration/apiAccess',
    },
    {
      step: 4,
      name: 'Company Verification',
      complete: false,
      url: '/PAARegistration/companyVerification',
    },
  ],
  [FLOW_ID.API_MARKETPLACE_VENDOR]: [
    {
      step: 1,
      name: 'Attestation',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 3,
      name: 'API Access',
      complete: false,
      url: '/PAARegistration/apiAccess',
    },
    {
      step: 4,
      name: 'Company Verification',
      complete: false,
      url: '/PAARegistration/companyVerification',
    },
  ],
  [FLOW_ID.API_MARKETPLACE_BILLING_TECHNICIAN]: [
    {
      step: 1,
      name: 'Attestation',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 3,
      name: 'Review & Confirm',
      complete: false,
      url: '/PAARegistration/reviewConfirm',
    },
  ],
  [FLOW_ID.API_MARKETPLACE_VENDOR_TECHNICIAN]: [
    {
      step: 1,
      name: 'Attestation',
      complete: false,
      url: '/PAARegistration/adminAttestation',
    },
    {
      step: 2,
      name: 'Account Information',
      complete: false,
      url: '/PAARegistration/accountInfo',
    },
    {
      step: 3,
      name: 'Review & Confirm',
      complete: false,
      url: '/PAARegistration/reviewConfirm',
    },
  ],
};
